import React, { createContext, useCallback, useContext, useState, useEffect } from 'react';
import MenuService from '../../services/menuService';
import { useAuth } from '../AuthProvider/AuthProvider';

const RoutesContext = createContext();

export const useRoutes = () => useContext(RoutesContext);

export const RoutesProvider = ({ children }) => {
  const { user, token, sessionLoading } = useAuth();
  const [routes, setRoutes] = useState({ menus: [], menuItems: [], itemSubmenus: [] });
  const [routesLoading, setRoutesLoading] = useState(true);

  const fetchRoutes = useCallback(async () => {
    if (sessionLoading) {
      return;
    }

    if (!user || !token) {
      setRoutes({ menus: [], menuItems: [], itemSubmenus: [] });
      setRoutesLoading(false);
      return;
    }

    try {
      setRoutesLoading(true);
      const userId = localStorage.getItem("userId");
      const response = await MenuService.getUserMenus(userId);

      const { menus, menuItems, itemSubmenus } = response;

      setRoutes({ menus, menuItems, itemSubmenus });
    } catch (error) {
      console.error('Error fetching routes:', error);
    } finally {
      setRoutesLoading(false);
    }
  }, [user, token, sessionLoading]);

  useEffect(() => {
    fetchRoutes();
  }, [fetchRoutes]);

  useEffect(() => {
    window.addEventListener("menus:refresh", fetchRoutes);
    return () => window.removeEventListener("menus:refresh", fetchRoutes);
  }, [fetchRoutes]);

  return (
    <RoutesContext.Provider value={{ ...routes, routesLoading }}>
      {children}
    </RoutesContext.Provider>
  );
};
